export default "https://cdn-static.gokick.com/assets/d05c895b658955f243e3d6e9c630166e56cf3faa/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";